import { JSX, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";

import { cn } from "@/utils/cn.ts";

import { IconBack } from "../icons/main.icons";

interface UpdateProfileLayoutProps {
  onBackClick: () => void;
  title: string;
  children: ReactNode;
  className?: string;
}

const UpdateProfileLayout = ({ onBackClick, title, children, className }: UpdateProfileLayoutProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "flex min-h-screen flex-1 flex-col items-center justify-center py-10 max-md:min-h-0 max-md:py-3",
        className,
      )}
    >
      <div className={"gate-header"}>
        <Button
          color={"black"}
          aria-label={t("Actions.back")}
          size={"small"}
          icon={<IconBack className={"size-5  stroke-on-primary"} />}
          onClick={onBackClick}
          className={"gate-back w-fit max-md:size-12 max-md:p-3"}
        >
          <span>{t("Actions.back")}</span>
        </Button>
        <h1 className={"gate-title text-center"}>{title}</h1>
        <div className="w-[3rem]"></div>
      </div>
      {children}
    </div>
  );
};

export default UpdateProfileLayout;
